<template>
  <div v-loading="loading" class="rj-page-card">
    <div class="rj-page-card__title">
      合同基本信息
    </div>
    <div class="rj-page-card__content">
      <div class="rj-row">
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              项目名称：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.projectName }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              订单日期：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.createTime }}
            </div>
          </div>
        </div>
        <!-- <div class="rj-col-3">
          <div class="rj-baseinfo" />
        </div> -->

        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              电子合同编号：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.contractNum }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              客户合同编号：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.customerContractNum }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              订单分类：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.contractType }}
            </div>
          </div>
        </div>

        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              供货单位(甲方)：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.supplyUnit }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              币种：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.currencyName }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              供货单位地址：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.supplyAddress }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              供货单位电话(甲方)：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.supplyPhone }}
            </div>
          </div>
        </div>

        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              订货单位(乙方)：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.orderUnit }}
            </div>
          </div>
        </div>

        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              订货单位电话(乙方)：
            </div>
            <el-input v-model="info.orderUnitPhone" />
          </div>
        </div>

        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              最终客户：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.finalCustomer }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              客户签约类型：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.customerContractType }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              区域：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.regionName }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              二级渠道名称：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.secondChannelName || '--' }}
              <!-- <el-tag type="danger" v-if="info.serviceSubjectCode==info.integratorCode">服务主体</el-tag> -->
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              二级渠道类型：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.secondaryChannelType || '--' }}
              <!-- <el-tag type="danger" v-if="info.serviceSubjectCode==info.finalIntegratorsId">服务主体</el-tag> -->
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              区域商务专员：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.regionBusinessCommissioner }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              售前姓名：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.preSalesName }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              外销姓名：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.salesManName }}
            </div>
          </div>
        </div>

        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              部门：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.departmentName }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              计量计点：
            </div>
            <div class="rj-baseinfo__item">
              {{ $store.getters['enumeration/getmeteringPoint'](info.meteringPoint) }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              贸易方式：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.tradeTerm }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              运输方式：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.modeOfShipping }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              销往区域：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.soldCountry }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              电源线规格(2pin)：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.powerCordSpecification }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              电源线规格(3pin)：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.threePlugPowerCord }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              发货方式：
            </div>
            <!--国际服务独立销售的单据,可编辑状态-->
            <div class="rj-baseinfo__item">
              <el-radio-group
                v-model="info.shipType"
                :disabled="isShowInternationalServiceOrders!==1"
              >
                <el-radio v-for="(type,index) in shipType" :key="index" :label="type.code">
                  {{ type.name }}
                </el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              结算方式：
            </div>
            <div class="rj-baseinfo__item">
              <el-radio-group v-model="info.salesType" disabled>
                <el-radio v-for="(type,index) in internationalSalesType" :key="index" :label="type.code">
                  {{ type.name }}
                </el-radio>
              </el-radio-group>
              <!-- {{ info.salesType }} -->
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              账期：
            </div>
            <div class="rj-baseinfo__item force-line-break">
              {{ info.accountPeriod || '--' }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              云桌面授权邮箱：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.authorizationEmail }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              目的地：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.destination }}
            </div>
          </div>
        </div>
        <div v-if="info.salesType==3" class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              即期/远期：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.atAfterSight=='1'? '即期':'远期' }}
            </div>
          </div>
        </div>
        <div v-if="info.atAfterSight==2" class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              远期时间：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.sightDate }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              齐套通知打款邮箱：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.setNoticeMail }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              税率：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.formTaxRate ? info.formTaxRate + '%' : '--' }}
            </div>
          </div>
        </div>

        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              是否使用返利：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.rebateAmount||0 }} {{ info.currencyName }}
              <!-- +  运费{{ info.freightUseRebate||0 }}元 -->
              <!-- <el-popover
                placement="bottom"
                width="400"
                trigger="click"
                @show="getEditRebateUsedList"
                v-if="info.rebateAmount"
              >
                <el-table :data="RebateUsedList" :max-height="400" border>
                  <el-table-column property="rebateNumber" label="返利编码" />
                  <el-table-column property="rebateTypeName" label="返利类型" />
                  <el-table-column property="useAmount" label="使用金额" />
                  <el-table-column property="description" label="备注说明" />
                </el-table>
                <el-button slot="reference" style="margin-left: 10px" type="text">查看</el-button>
              </el-popover> -->
            </div>
          </div>
        </div>

        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              仓库：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.warehouseName || '--' }}
            </div>
          </div>
        </div>
        <!-- 增加是否返现金点字段 -->
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              是否返现金点：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.isCashbackPoint? '是' : '否' }}
            </div>
          </div>
        </div>
        <!-- 现金点比例 -->
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              现金点比例：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.cashPointRatio || '--' }}
            </div>
          </div>
        </div>
        <!-- 采购类型 -->
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              采购类型：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.purchaseType }}
            </div>
          </div>
        </div>
        <!-- 业务类型 -->
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              业务类型：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.projectType }}
            </div>
          </div>
        </div>
        <div class="rj-col-1">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              收款银行：
            </div>
            <div class="rj-baseinfo__item">
              {{ activebankInfo }}
            </div>
          </div>
        </div>
        <div class="rj-col-1">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              补充条款：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.additionalTerms }}
            </div>
          </div>
        </div>
        <div class="rj-col-1">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              备注说明：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.remarks }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="es6">
import { mapState } from 'vuex';
import { getRebateUsedList } from '@/API';
export default {
  props: {
    info: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    ...mapState({
      shipType: state => state.enumeration.shipType,
      internationalSalesType: state => state.enumeration.internationalSalesType
    }),
    activebankInfo () {
      let bank = '';
      this.info.bankInfos && this.info.bankInfos.forEach((item) => {
        if (item.openBankId === this.info.paymentBankId) {
          bank = item.openBankName;
        }
      });
      return bank;
    }
  },
  data () {
    return {
      loading: false,
      RebateUsedList: [],
      RebateUsedListLoading: false,
      isShowInternationalServiceOrders: 0// 是否是国际服务订单,0国内,1国际,用于控制电源线字段是否显示
    };
  },
  methods: {
    // 验证表单
    validate () {
      return new Promise((resolve, reject) => {
        if (this.info.supplyUnitPhone === '') {
          this.$message.error('请填写订货单位电话');
          resolve(false);
        }
        resolve(true);
      });
    },
    getEditRebateUsedList () {
      if (this.RebateUsedList.length) {
        return;
      }
      this.RebateUsedListLoading = true;
      getRebateUsedList({
        contractId: this.info.id
      }).then((res) => {
        const json = res.data;
        this.RebateUsedListLoading = false;
        if (json.status === '200') {
          this.RebateUsedList = json.data;
        }
      }).catch(() => {
        this.RebateUsedListLoading = false;
      });
    }
  },
  mounted () {
    this.isShowInternationalServiceOrders = Number(this.$route.query.isShowInternationalService);
  }
};
</script>
